const Footer = () => {
    return (
        <footer className="h-42 pt-10 text-center">
      <div className="w-10/12 mx-auto">
        <div className="md:flex justify-center text-center ">
          <span className="font-playfair text-yellow text-2xl">
            Thanks for passing by.
          </span>
          </div>
         <a href="https://github.com/IgnacioPicca"><span>iPicca.dev</span></a>
      </div>
    </footer>
    )
}

export default Footer;